// extracted by mini-css-extract-plugin
module.exports = {"heading":"style_heading__3d894","mob":"style_mob__1CcLc"};